import tpl from './templates';
// body country city drive engine gearbox generation isNew location make makeTranslate model year

export const PRITSEPY = {
  city: tpl.city,
  city_make: tpl.cityMake,
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/pritsepy/index.js